import http from "../../http-common";

const get = (data) => http.post("/ErrorConsult/FilterErrorConsult", data);

export default { get };
